import { defineStore, storeToRefs } from "pinia"
import { ref } from "vue"
import { useTrackerStore } from "@/stores/tracker"

export const useSettingsStore = defineStore(
	"settings",
	() => {
		const mapCenter = ref([0, 0])
		const mapZoom = ref(5)
		const mapStyle = ref("map")
		const mapStyle3d = ref(false)
		const mapStylePersitentUntil = ref(null)
		const mapVisibleMarkercategories = ref([])
		const mapVisibleTrackers = ref([])
		const mapRouteFrom = ref(null)
		const mapRouteTo = ref(null)
		const mapShowDeviceLocation = ref(false)
		const mapShowPhotos = ref(false)
		const mapShowRouteLabels = ref(true)
		const mapShowLegend = ref(true)
		const ignoreUpdatesUntil = ref(null)
		const ignoreEnablePushUntil = ref(null)
		const ignorePhotoAccessHintUntil = ref(null)
		const tourDefaultRouteStyle = ref("segment.tours")
		const tourOvernightstaysVisible = ref(false)
		const tourPhotosVisible = ref(false)
		const seen = ref([])
		const telemetryChartDays = ref(1)
		const markerListOrder = ref("created_at.desc")
		const markercategoryListOrder = ref("created_at.asc")
		const tourListOrder = ref("started_at.desc")
		const tourAnalyzeTrackerId = ref(null)
		const alarmHistorySeenUntil = ref(null)
		const alarmHistorySeenIds = ref([])
		const alarmHistoryHiddenTrackerIds = ref([])
		const alarmHistoryHideSeen = ref(false)
		const useUnfilteredPositionlogs = ref(false)

		// user settings
		const coordinatesFormat = ref("dd") // dd, dms

		const { trackersById } = storeToRefs(useTrackerStore())

		const reset = () => {
			mapCenter.value = [0, 0]
			mapZoom.value = 5
			mapStyle.value = "map"
			mapStyle3d.value = false
			mapStylePersitentUntil.value = null
			mapVisibleMarkercategories.value = []
			mapVisibleTrackers.value = []
			mapRouteFrom.value = null
			mapRouteTo.value = null
			mapShowDeviceLocation.value = false
			mapShowPhotos.value = false
			mapShowRouteLabels.value = true
			mapShowLegend.value = true
			ignoreUpdatesUntil.value = null
			ignoreEnablePushUntil.value = null
			ignorePhotoAccessHintUntil.value = null
			tourDefaultRouteStyle.value = "segment.tours"
			tourOvernightstaysVisible.value = false
			tourPhotosVisible.value = false
			seen.value = []
			telemetryChartDays.value = 1
			markerListOrder.value = "created_at.desc"
			markercategoryListOrder.value = "created_at.asc"
			tourListOrder.value = "started_at.desc"
			tourAnalyzeTrackerId.value = null
			alarmHistorySeenUntil.value = null
			alarmHistorySeenIds.value = []
			alarmHistoryHiddenTrackerIds.value = []
			alarmHistoryHideSeen.value = false
		}

		const validate = () => {
			// validate mapVisibleTrackers
			mapVisibleTrackers.value = mapVisibleTrackers.value.filter((mapVisibleTracker) => {
				return trackersById.value[mapVisibleTracker.trackerId] !== undefined
			})
		}

		const isSeen = (identifier) => {
			return seen.value.includes(identifier)
		}

		const markSeen = (identifier) => {
			if (!isSeen(identifier)) {
				seen.value.push(identifier)
			}
		}

		return {
			reset,
			mapCenter,
			mapZoom,
			mapStyle,
			mapStyle3d,
			mapStylePersitentUntil,
			mapVisibleMarkercategories,
			mapVisibleTrackers,
			mapRouteFrom,
			mapRouteTo,
			mapShowDeviceLocation,
			mapShowPhotos,
			mapShowRouteLabels,
			mapShowLegend,
			ignoreUpdatesUntil,
			ignoreEnablePushUntil,
			ignorePhotoAccessHintUntil,
			tourDefaultRouteStyle,
			tourOvernightstaysVisible,
			tourPhotosVisible,
			validate,
			seen,
			markSeen,
			isSeen,
			coordinatesFormat,
			telemetryChartDays,
			markerListOrder,
			markercategoryListOrder,
			tourListOrder,
			tourAnalyzeTrackerId,
			alarmHistorySeenUntil,
			alarmHistorySeenIds,
			alarmHistoryHiddenTrackerIds,
			alarmHistoryHideSeen,
			useUnfilteredPositionlogs,
		}
	},
	{
		persist: true,
	},
)
